import { useEffect, useRef, useState } from 'react';

// Extracted from StudentProfile.js (Phase 3 of the platform-health plan:
// getting the file under ~600 lines needs pulling logic into hooks, not
// just JSX into components). Detects whether the "Money this month" /
// "Planned income" stat cards are showing an ellipsis (text wider than
// the card), so the JSX can swap in a tooltip instead of the label.
export function useStatCardTruncation({ calculateStudentStats, priceCurrency }) {
  const moneyThisMonthRef = useRef(null);
  const plannedIncomeRef = useRef(null);
  const [isMoneyThisMonthTruncated, setIsMoneyThisMonthTruncated] = useState(false);
  const [isPlannedIncomeTruncated, setIsPlannedIncomeTruncated] = useState(false);

  // Проверяем, обрезается ли текст в ячейках с деньгами
  useEffect(() => {
    const checkTruncation = () => {
      // Используем requestAnimationFrame для проверки после рендера
      requestAnimationFrame(() => {
        if (moneyThisMonthRef.current) {
          const element = moneyThisMonthRef.current;
          // Проверяем, обрезается ли текст (есть ли ellipsis)
          const isTruncated = element.scrollWidth > element.clientWidth ||
                              element.offsetWidth < element.scrollWidth;
          setIsMoneyThisMonthTruncated(isTruncated);
        }
        if (plannedIncomeRef.current) {
          const element = plannedIncomeRef.current;
          const isTruncated = element.scrollWidth > element.clientWidth ||
                              element.offsetWidth < element.scrollWidth;
          setIsPlannedIncomeTruncated(isTruncated);
        }
      });
    };

    // Проверяем сразу и после небольшой задержки для надежности
    checkTruncation();
    const timeoutId1 = setTimeout(checkTruncation, 50);
    const timeoutId2 = setTimeout(checkTruncation, 200);
    window.addEventListener('resize', checkTruncation);

    return () => {
      clearTimeout(timeoutId1);
      clearTimeout(timeoutId2);
      window.removeEventListener('resize', checkTruncation);
    };
  }, [calculateStudentStats, priceCurrency]);

  return { moneyThisMonthRef, plannedIncomeRef, isMoneyThisMonthTruncated, isPlannedIncomeTruncated };
}
